@if (!state.isSmall) {
  <dojo-button
    [matMenuTriggerFor]="disabled() ? null : menu"
    #menuTrigger="matMenuTrigger"
    [fill]="'outline'"
    [size]="size()"
    [customColor]="isSelected() ? 'sky' : undefined"
    [class.applied-filters]="isSelected()"
    [class.filter-disabled]="disabled()"
    [disabled]="disabled()"
    class="max-w-[300px]"
  >
    <span class="truncate font-medium">{{ displayLabel() }}</span>
    @if (showCount()) {
      <div class="count-badge ml-2">{{ count() }}</div>
    }
    <dojo-icon [icon]="menuTrigger.menuOpen ? 'chevron-up' : 'chevron-down'" class="ml-2" />
  </dojo-button>

  <mat-menu #menu="matMenu" class="custom-mat-menu {{ customMatMenuClass() }}">
    <div class="flex flex-col" (click)="$event.stopPropagation()">
      <div class="p-1.5">
        @if (contentTemplate(); as template) {
          <ng-container *ngTemplateOutlet="template" />
        }
      </div>
      <div class="border-t border-neutral-200">
        <button mat-menu-item class="text-sm" (click)="onClear()" [disabled]="!isSelected()">
          <span class="link-component" [class.!text-disabled]="!isSelected()">{{ clearLabelKey() | transloco }}</span>
        </button>
      </div>
    </div>
  </mat-menu>
}

@if (state.isSmall) {
  <dojo-button
    [fill]="'outline'"
    [size]="size()"
    [customColor]="isSelected() ? 'sky' : undefined"
    [class.applied-filters]="isSelected()"
    [class.filter-disabled]="disabled()"
    [disabled]="disabled()"
    (click)="onButtonClick()"
    class="max-w-[300px]"
  >
    <span class="truncate font-medium">{{ displayLabel() }}</span>
    @if (showCount()) {
      <div class="count-badge ml-2">{{ count() }}</div>
    }
  </dojo-button>
}
